import React from 'react';
import {
  Navigate,
  Outlet,
  Route,
  Routes as RouterRoutes,
} from 'react-router-dom';
import AuthenticatedWall from './util/walls/AuthenticatedWall';
import Login from './components/Login';
import UnauthenticatedWall from './util/walls/UnauthenticatedWall';
import * as Routes from './routes';
import Users from './components/Users';
import Withdrawals from './components/Transfers/Withdrawals';
import Deposits from './components/Transfers/Deposits';
import Logs from './components/Logs';
import ThemeConfig from './components/Config/pages/ThemeConfig';
import SettingsConfig from './components/Config/pages/SettingsConfig';
import ProfileConfig from './components/Config/pages/ProfileConfig';
import CommunicationConfig from './components/Config/pages/CommunicationConfig';
import WhitelabelConfigHeader from './components/Config/components/SubHeader';
import { ZigStub } from '@ui/index';
import { useTranslation } from 'react-i18next';

const Router: React.FC = () => {
  const { t } = useTranslation('common');
  return (
    <RouterRoutes>
      <Route element={<AuthenticatedWall />}>
        <Route path={Routes.ROUTE_USERS} element={<Users />} />
        <Route path={Routes.ROUTE_DEPOSITS} element={<Deposits />} />
        <Route path={Routes.ROUTE_WITHDRAWALS} element={<Withdrawals />} />
        <Route path={Routes.ROUTE_LOGS} element={<Logs />} />
        <Route
          path={Routes.ROUTE_CONFIG_PARENT}
          element={
            <>
              <WhitelabelConfigHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path={Routes.ROUTE_CONFIG_THEME}
            element={<ThemeConfig />}
          ></Route>
          <Route
            path={Routes.ROUTE_CONFIG_SETTINGS}
            element={<SettingsConfig />}
          ></Route>
          <Route
            path={Routes.ROUTE_CONFIG_PROFILE}
            element={<ProfileConfig />}
          ></Route>
          <Route
            path={Routes.ROUTE_CONFIG_COMMUNICATION}
            element={<CommunicationConfig />}
          ></Route>
        </Route>
      </Route>

      <Route element={<UnauthenticatedWall />}>
        <Route path={Routes.ROUTE_LOGIN} element={<Login />} />
      </Route>

      <Route path='/' element={<Navigate to={Routes.ROUTE_USERS} replace />} />
      <Route
        path='*'
        element={
          <ZigStub title={t('404.title')} description={t('404.description')} />
        }
      />
    </RouterRoutes>
  );
};

export default Router;
